const availableVariants = {
    //Backlight Models
    '_100673': {
        sku: 100673,
        type: 'TPF',
        technology: 'tree',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: false,
        has_backlight: true,
        color: 'white',
        isNew: true,
    },
    '_100674': {
        sku: 100674,
        type: 'TPF',
        technology: 'tree',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: false,
        has_backlight: true,
        color: 'anthracite',
        isNew: true,
    },
    '_100675': {
        sku: 100675,
        type: 'TPF',
        technology: 'air',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: false,
        has_backlight: true,
        color: 'white',
        isNew: true,
    },
    '_100676': {
        sku: 100676,
        type: 'TPF',
        technology: 'air',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: false,
        has_backlight: true,
        color: 'anthracite',
        isNew: true,
    },

    // IP44 + Backlight
    '_100608': { //Touch Pure Flex Tree White
        sku: 100608,
        type: 'TPF',
        technology: 'tree',
        power_mode: '24v',
        ip_rating: 'ip44',
        has_temperature: true,
        has_humidity: false,
        has_co2: false,
        has_backlight: true,
        color: 'white',
    },
    '_100609': { //Touch Pure Flex Tree Anthracite
        sku: 100609,
        type: 'TPF',
        technology: 'tree',
        power_mode: '24v',
        ip_rating: 'ip44',
        has_temperature: true,
        has_humidity: false,
        has_co2: false,
        has_backlight: true,
        color: 'anthracite',
    },
    '_100610': { //Touch Pure Flex 24V Air White
        sku: 100610,
        type: 'TPF',
        technology: 'air',
        power_mode: '24v',
        ip_rating: 'ip44',
        has_temperature: true,
        has_humidity: false,
        has_co2: false,
        has_backlight: true,
        color: 'white',
    },
    '_100611': { //Touch Pure Flex 24V Air Anthracite
        sku: 100611,
        type: 'TPF',
        technology: 'air',
        power_mode: '24v',
        ip_rating: 'ip44',
        has_temperature: true,
        has_humidity: false,
        has_co2: false,
        has_backlight: true,
        color: 'anthracite',
    },

    //CO2 Models
    '_100612': { //Touch Pure Flex CO2 Tree White
        sku: 100612,
        type: 'TPF',
        technology: 'tree',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: true,
        has_backlight: true,
        color: 'white',
        isNew: true,
    },
    '_100613': { //Touch Pure Flex CO2 Tree Anthracite
        sku: 100613,
        type: 'TPF',
        technology: 'tree',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: true,
        has_backlight: true,
        color: 'anthracite',
        isNew: true,
    },
    '_100614': { //Touch Pure Flex 24V CO2 Air White
        sku: 100614,
        type: 'TPF',
        technology: 'air',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: true,
        has_backlight: true,
        color: 'white',
        isNew: true,
    },
    '_100615': { //Touch Pure Flex 24V CO2 Air Anthracite
        sku: 100615,
        type: 'TPF',
        technology: 'air',
        power_mode: '24v',
        ip_rating: 'ip20',
        has_temperature: true,
        has_humidity: true,
        has_co2: true,
        has_backlight: true,
        color: 'anthracite',
        isNew: true,
    },
    
    '_100509': { //Touch Pure Flex Battery Air White
        sku: 100509,
        type: 'TPF',
        technology: 'air',
        power_mode: 'battery',
        ip_rating: 'ip44',
        has_temperature: true,
        has_humidity: true,
        has_co2: false,
        has_backlight: false,
        color: 'white',
    },
    '_100510': { //Touch Pure Flex Battery Air Anthracite
        sku: 100510,
        type: 'TPF',
        technology: 'air',
        power_mode: 'battery',
        ip_rating: 'ip44',
        has_temperature: true,
        has_humidity: true,
        has_co2: false,
        has_backlight: false,
        color: 'anthracite',
    },
};

export default availableVariants;